import React from "react";
import PropTypes from "prop-types";
import SvgIcon from "../../../../../parts/SvgIcon";
import { capitalizeFirstLetter } from "../../../../../utils/string-helpers";
import {
  calculateMacros,
  calculateMeasurementPerUnit,
  completeVolumeUnits,
  completeWeightUnits,
  weightUnits,
} from "../../../../../utils/nutrition-util";

export const MostUsedFoodItems = ({
  data = [],
  setFoodActionState,
  location,
  onItemSelect,
}) => {
  /**
   * Function to update the state from AddFoodModal
   * @param {*} newState
   * @returns
   */
  const updateStateFromAddFoodModal = (newState) =>
    setFoodActionState((prevState) => ({ ...prevState, ...newState }));

  /**
   * Select the item from the search bar
   * @param {*} item
   */
  const handleItemSelect = (item) => {
    const {
      unitOfMeasure,
      quantityDescription,
      name,
      quantityNumber,
      measurementsValue,
    } = item;

    const unitOfMeasureForDefaultMeasure = unitOfMeasure || "g";

    const defaultMeasure = {
      value: "custom",
      text: `${quantityDescription} - ${calculateMeasurementPerUnit(
        quantityNumber,
        measurementsValue
      )} ${unitOfMeasureForDefaultMeasure}`,
    };
    let optionsToSelect = !unitOfMeasure
      ? [defaultMeasure]
      : weightUnits.includes(unitOfMeasure)
      ? [defaultMeasure, ...completeWeightUnits]
      : [defaultMeasure, ...completeVolumeUnits];

    updateStateFromAddFoodModal({
      unitOfMeasureOptions: optionsToSelect,
      unitOfMeasure: defaultMeasure.value,
      isSearching: false,
      selectedItem: item,
      searchValue: name || "",
    });
    if (onItemSelect) {
      onItemSelect(item);
    }
  };

  return data.map((item) => {
    const {
      _id,
      quantityNumber = 1,
      quantityDescription = "Serving",
      name,
      type,
      foods = [],
      proteins: itemProteins,
      carbs: itemCarbs,
      fats: itemFats,
      calories: itemCalories,
    } = item;
    const isMeal = type === "meal";
    const isRecipe = type === "recipe";
    const icon = `/img/new-icons/${type}.svg`;
    const url = isRecipe
      ? `/coaching-portal/widgets?widget=${item?.widget}&section=manager&type=recipe`
      : isMeal
      ? `/actions/refresh?modal[type]=build-meal&mealId=${_id}`
      : `/actions/refresh?modal[type]=handle-meal-planner-food&foodId=${_id}`;
    const quantityDescriptionToShow =
      type === "recipe" && quantityNumber > 1
        ? `${quantityDescription}s`
        : quantityDescription;
    const servings = `${quantityNumber} ${quantityDescriptionToShow}`;

    const itemDetails = {
      itemProteins,
      itemCarbs,
      itemFats,
      itemCalories,
      foodKey: "foodDetails",
    };
    const { proteins, carbs, fats, calories } = calculateMacros({
      isMeal,
      isRecipe,
      foods,
      itemDetails,
    });

    return (
      <button
        key={_id}
        className="info-food-button"
        onClick={() => {
          handleItemSelect(item);
        }}
      >
        <div className="main-food-info">
          <div className="title-food">
            <span>{name}</span>
            <span className="opacity-70">{servings}</span>
          </div>
          {location === "all" || location === "recipes" ? (
            <div className="identifier">
              <SvgIcon src={icon} noFilterOnLight={false} />
              <span className="opacity-70">{capitalizeFirstLetter(type)}</span>
            </div>
          ) : (
            <div className="actions">
              <a
                className="edit"
                href={url}
                onClick={(e) => e.stopPropagation()}
              >
                <SvgIcon
                  src={`/img/new-icons/edit-pencil.svg`}
                  noFilterOnLight={false}
                />
              </a>
            </div>
          )}
        </div>
        <div className="nutrition-info">
          <span>P {proteins}g </span>
          <span>&#8226;</span>
          <span>C {carbs}g</span>
          <span>&#8226;</span>
          <span>F {fats}g</span>
          <span>&#8226;</span>
          <span>kCal {calories}</span>
        </div>
      </button>
    );
  });
};
MostUsedFoodItems.propTypes = {
  data: PropTypes.array,
  setFoodActionState: PropTypes.func,
  onItemSelect: PropTypes.func,
  location: PropTypes.string,
};
